import { useCallback, useMemo, useState } from 'react'

import { useUser } from '@/modules/auth'
import {
  loadPhoneNoticeConfirmedAt,
  persistPhoneNoticeConfirmedAt,
} from './prefs'

// Until the user is known the notice counts as confirmed, so it never flashes open.
export const usePhoneNoticeConfirmed = () => {
  const userId = useUser()?.id ?? null
  const [confirmedFor, setConfirmedFor] = useState<string | null>(null)
  const confirmedBefore = useMemo(
    () => userId === null || loadPhoneNoticeConfirmedAt(userId) !== null,
    [userId],
  )

  const confirm = useCallback(() => {
    if (userId === null) return
    persistPhoneNoticeConfirmedAt(userId, new Date().toISOString())
    setConfirmedFor(userId)
  }, [userId])

  return { isConfirmed: confirmedBefore || confirmedFor === userId, confirm }
}
